import { render, staticRenderFns } from "./revisikirimanfrm.vue?vue&type=template&id=5b6b5642"
import script from "./revisikirimanfrm.vue?vue&type=script&lang=js"
export * from "./revisikirimanfrm.vue?vue&type=script&lang=js"
import style0 from "./revisikirimanfrm.vue?vue&type=style&index=0&id=5b6b5642&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports